import { IconChevronRight } from '@tabler/icons-react'
import clsx from 'clsx'
import { HTMLMotionProps, motion } from 'motion/react'
import { ReactNode } from 'react'
import styles from './ListItem.module.css'

export interface ListItemProps extends HTMLMotionProps<'div'> {
	children?: ReactNode
	showArrowRight?: boolean
}
export default function ListItem({
	children,
	className,
	showArrowRight = false,
	...props
}: ListItemProps) {
	return (
		<motion.div
			className={clsx(styles.root, className)}
			data-clickable-feedback={showArrowRight || props['data-clickable-feedback']}
			{...props}
		>
			{children}
			{showArrowRight && <IconChevronRight className={styles.icon} />}
		</motion.div>
	)
}
